import * as storage from '@actions/storage';

/**
 * ⚠️ One-shot legacy storage migration. Created 2026-06-16 — safe to delete
 * after ~2026-09-16, once no active session predates the prefixed (`ef_`)
 * storage. Reads pre-migration localStorage and promotes values to the wrapper.
 */

const LEGACY_STATE_KEY = 'localState';
const META_EVENT_ID_KEY = 'metaEventId';

// metaEventId used to live in the localState blob (localState.formDataContext);
// promote it to its own key, then strip it from the blob.
const recoverMetaEventId = (): void => {
  if (storage.get(META_EVENT_ID_KEY) !== null) return;

  let blob;
  try {
    blob = JSON.parse(localStorage.getItem(LEGACY_STATE_KEY) ?? 'null');
  } catch {
    return;
  }

  const legacyId = blob?.formDataContext?.metaEventId;
  if (!legacyId) return;

  storage.set(META_EVENT_ID_KEY, legacyId);

  const { metaEventId, ...formDataContext } = blob.formDataContext;
  localStorage.setItem(
    LEGACY_STATE_KEY,
    JSON.stringify({ ...blob, formDataContext }),
  );
};

export const recoverLegacyStorage = (): void => {
  recoverMetaEventId();
};
